<style scoped>
.logo {
  max-width: 55%;
}
</style>

<template>
  <div align="center" class="pa-6">
    <img src="../../resources/imgs/logo-light.png" alt="logo" class="logo" />
  </div>
</template>

<script>
export default {
  name: 'AnchorLogo',
};
</script>
